import { useEffect, useState } from 'react'
import { api } from '@pilot-hub/api-client'

// Aufforderungen bei Flügen, die die Cloud API erkennt (siehe pilot-api /pilot/aufforderungen).
// Ein gemeinsamer Abruf für Banner (Layout) und Co-Pilot-Seite: läuft, solange mindestens eine Komponente zuhört.

export interface VorflugAuff {
  drohne_id: number; drohne: string; einsatz_id: number; einsatz_titel: string; einsatz_typ?: string | null
  eingeschaltet_am: string | null; mehrere_empfaenger: boolean
  status: 'OFFEN' | 'VON_MIR' | 'IN_ARBEIT' | 'UEBERNOMMEN'; von: string | null
}
export interface NachflugAuff {
  flug_id: number; flug_nr: string | null; einsatz_id: number; einsatz_titel: string | null; instanz_id: number
  drohne: string | null; endzeit: string; wieder_in_der_luft: boolean
}
export interface VorflugFehltAuff {
  flug_id: number; flug_nr: string | null; einsatz_id: number; einsatz_titel: string | null; instanz_id: number
  drohne: string | null; rolle: 'PILOT' | 'CO_PILOT'; laeuft: boolean
}
export interface LandungAuff {
  flug_id: number; flug_nr: string | null; einsatz_id: number; instanz_id: number; drohne: string | null
  mode_code: number; modus: string
}
export interface VorflugHinweis { key: string; drohne: string; grund: string; text: string }
export interface Aufforderungen {
  vorflug: VorflugAuff[]; nachflug: NachflugAuff[]; vorflug_fehlt: VorflugFehltAuff[]; landung: LandungAuff[]
  vorflug_hinweise: VorflugHinweis[]
}

const LEER: Aufforderungen = { vorflug: [], nachflug: [], vorflug_fehlt: [], landung: [], vorflug_hinweise: [] }
const INTERVALL_MS = 5000

let daten: Aufforderungen = LEER
let geladen = false
const hoerer = new Set<() => void>()
let timer: number | null = null

function abrufen() {
  if (document.visibilityState === 'hidden') return
  // Fehler: letzten Stand behalten (kein "nichts zu tun" vortäuschen); Netzwerkfehler meldet der Interceptor
  api.get('/pilot/aufforderungen').then(r => {
    daten = { ...LEER, ...(r.data as Partial<Aufforderungen>) }
    geladen = true
    hoerer.forEach(h => h())
  }).catch(() => {})
}

export function aufforderungenNeuLaden() { abrufen() }

export function useAufforderungen(): { daten: Aufforderungen; geladen: boolean } {
  const [, setTick] = useState(0)
  useEffect(() => {
    const h = () => setTick(t => t + 1)
    hoerer.add(h)
    if (hoerer.size === 1) {
      abrufen()
      timer = window.setInterval(abrufen, INTERVALL_MS)
      document.addEventListener('visibilitychange', abrufen)
    } else if (geladen) h()
    return () => {
      hoerer.delete(h)
      if (hoerer.size === 0 && timer) {
        window.clearInterval(timer); timer = null
        document.removeEventListener('visibilitychange', abrufen)
      }
    }
  }, [])
  return { daten, geladen }
}
